import React from "react";
import RegisterPage from "../components/RegisterPage";
import { useHSE } from "../lib/store";

const STATUS = {
  Valid: { bg: "#DCFCE7", color: "#166534" },
  "Expiring Soon": { bg: "#FEF3C7", color: "#854D0E" },
  Expired: { bg: "#FEE2E2", color: "#7F1D1D" },
};

export default function Training() {
  const { data, siteNames } = useHSE();
  const total = data.trainings.length;
  const valid = data.trainings.filter((t) => t.status === "Valid").length;
  const compliance = total ? Math.round((valid / total) * 100) : 0;
  const expiring = data.trainings.filter((t) => t.status === "Expiring Soon").length;
  const expired = data.trainings.filter((t) => t.status === "Expired").length;

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <Stat label="Compliance" value={`${compliance}%`} sub="vs target 95%" tone={compliance >= 95 ? "safe" : "warning"} />
      <Stat label="Total Records" value={total} />
      <Stat label="Expiring Soon" value={expiring} tone="warning" />
      <Stat label="Expired" value={expired} tone="critical" />
    </div>
  );

  return (
    <RegisterPage
      title="Training Records"
      subtitle="Inhouse · Induction · Specific · External"
      storeKey="trainings"
      idPrefix="TRN"
      topPanels={Top}
      columns={[
        { key: "id", label: "ID" },
        { key: "employeeName", label: "Employee" },
        { key: "employeeId", label: "Emp ID" },
        { key: "site", label: "Site" },
        { key: "department", label: "Dept" },
        { key: "type", label: "Type" },
        { key: "trainer", label: "Trainer" },
        { key: "date", label: "Date" },
        { key: "expiryDate", label: "Expiry" },
        { key: "status", label: "Status" },
      ]}
      badgeMap={{ status: STATUS }}
      formFields={[
        { key: "id", label: "Training ID" },
        { key: "employeeName", label: "Employee Name" },
        { key: "employeeId", label: "Employee ID" },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "department", label: "Department", type: "select", options: data.settings.departments },
        { key: "type", label: "Training Type", type: "select", options: ["Inhouse", "Induction", "Specific", "External"] },
        { key: "trainer", label: "Trainer" },
        { key: "date", label: "Date", type: "date" },
        { key: "expiryDate", label: "Expiry Date", type: "date" },
        { key: "status", label: "Status", type: "select", options: ["Valid", "Expiring Soon", "Expired"] },
      ]}
    />
  );
}

function Stat({ label, value, sub, tone = "neutral" }) {
  const c = { safe: "#54A57B", warning: "#FFB517", critical: "#DC2626", neutral: "#183C55" }[tone];
  return (
    <div className="command-card p-3.5 border-l-4" style={{ borderLeftColor: c }}>
      <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">{label}</div>
      <div className="font-heading font-bold text-2xl tabular text-[#0E2336] mt-0.5">{value}</div>
      {sub && <div className="text-[10px] text-slate-400 mt-0.5">{sub}</div>}
    </div>
  );
}
